import { Helmet } from "react-helmet-async";
import { BuildingProject, Layout } from "../../components";
import { ProjectsController } from "../../controllers";

import { connect } from "react-redux";
import { LinearProgress } from "@mui/material";



class Projects extends ProjectsController {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.getList()
    }
    render() {
        const { projectList , loading} = this.state;
        return (
            <Layout title=" مسکن متری  ">
                <Helmet>
                    <title>  مسکن متری   | بیمه زندگی هامرز </title>
                </Helmet>
                {loading ?
                    <LinearProgress />
                    :

                    <>
                <div className="project scrollbar ">
                    {/* <span className="insurance-rate-title">
                        پروژه های ساختمانی          </span> */}
                    <p className="insurance-rate-description">
خواهشمند است یکی از پروژه های زیر را جهت سرمایه گذاری  ،  انتخاب نمایید.                            </p>
                    <div className="project-cards">
                        {projectList && projectList.length > 0 && projectList?.map((item: any, index: number) => (
                            <BuildingProject contentLoading={loading} item={item} />
                        )
                        )}
                    </div>
                </div>
                    </>
                    }

            </Layout>
        )
    }
}

const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,

    };
};
export default connect(mapStateToProps)(Projects);
